import React,{ useEffect, useState,useCallback } from 'react';
import Pagination from '@src/common/Pagination';
import * as HELPER from "@src/config/helper";
import {useDispatch } from 'react-redux';
import CommonModel from './commonModel';
import { getCommissionDetail } from '@store/slices/commission';
import FullPageLoader from '@common/FullPageLoader';
import { COMMISSION_SUB_TAB_KEY, FILTER_TYPE } from '@src/config/id/constant';
import { useLanguage } from '@src/context/LanguageContext';



function CommissionListTable(props: any) {
    let { commissionList, paginationData, selectedFilters,tab,getCommissionListing,mainTab} = props;  
    const [showModal, setShowModal] = useState<boolean>(false);
    const [data,setData] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const {translations} = useLanguage();

    const handleShow = async (id: number,leadData:any) => {
        await fetchData({lead_id:id});
        setShowModal(true)
    };

    const handleClose = () => setShowModal(false);

    const dispatch: any = useDispatch();

    const fetchData:any = useCallback(async (params:any) => {
        try { 
            setLoading(true);
           const res: any = await dispatch(getCommissionDetail(params));
            if (res.status===200) {
                setData(res.data);
                setLoading(false);
            }
        } catch (error) {
           console.error("Failed to fetch master config:", error);
           setLoading(false);
        }
    }, [dispatch]);

    


    const handleRequestData = (params: any) => {
        let apiParams = {
            ...selectedFilters,
            page_number: params.page_no
        }

        props.getInsuranceListing(apiParams)

    }
 
    return (
        <React.Fragment>
              <FullPageLoader show={loading} />
        <div className={`lead-list-data-table data-table managepanel-tab wap-table ${props.tab}-points-data-table`}>
            <table >
                <thead>
                    <tr>
                       <th>
                        {translations?.COMMISSION?.POINT_COMMISSION}
                       </th>
                       <th>
                        {translations?.COMMISSION?.TRANSACTION_DATE}
                       </th>
                       <th>
                        {translations?.COMMISSION?.INS_ID}
                       </th>
                       <th>
                        {translations?.COMMISSION?.CUSTOMER_NAME}
                       </th>
                       {
                        (tab === COMMISSION_SUB_TAB_KEY.ALL) && (
                        <th>
                           {translations?.COMMON_MSG?.ACTION}
                        </th>
                        )
                       }
                    </tr>
                </thead>
               <tbody>
                { commissionList?.length > 0 && commissionList?.map((item:any, index:number) => (
                    <tr key={index}>
                   <td>
                    {tab === COMMISSION_SUB_TAB_KEY.ALL ? (
                        <>
                        <div className='d-flex'>
                            <span className={item.type === 'p' ? 'point' : 'commission'}>{item.type?.toUpperCase()}</span>{" "}
                            {HELPER.addCurrencyFormatting(item.amount) || 0}

                        </div>
                        </>
                    ) : (
                        tab===COMMISSION_SUB_TAB_KEY.POINTS ? 'Pts ' + item.amount || 0 : HELPER.addCurrencyFormatting(item.amount) || 0
                    )}
                    </td>
                   <td>
                    {item?.created_at
                        ? HELPER.formatDate(new Date(item.created_at), "dd mon yyyy")
                        : "-"}
                    </td>
                    <td>{item.lead_code || 0}</td>
                    <td>{item.name || 0}</td>
                    {
                        (tab === COMMISSION_SUB_TAB_KEY.ALL) && (
                            <td> <i className="ic-remove_red_eyevisibility f-18" onClick={() => handleShow(item.insurance_id, item)}></i></td>
                            
                            )}
                    </tr>
                ))}
                </tbody>
            </table>
                {
                   commissionList?.length === 0 &&  <div className='no-data-found'>No data found</div>
                }
            <CommonModel
                show={showModal}
                handleClose={handleClose}
                filterType={FILTER_TYPE.EARNING_DETAILS}
                showDateRange={false}
                api={getCommissionListing}
                selectedFilters={selectedFilters}
                data={data}
                mainTab={mainTab}
            />
            {/* {(paginationData && paginationData['total'] > DEFAULT_PAGINATION_COUNT) && <Pagination paginateData={{
                page,
                loading: false,
                totalLengthWithoutPagination: paginationData['total'],
                paginationData,
                filteredData: selectedFilters
            }}
                sendRequestDataToParent={handleRequestData} />} */}
        </div >
        </React.Fragment>

    )
}

export default CommissionListTable